"use strict";
var INITDATA = "initData";
var GROUPSPERPAGE = 10;
var MESSAGE_TIMEOUT = 8000;
var DEFAULT_GRADES_QUERY = "?defaultGrades=9,10,11,12";
var GroupsController = (function () {
    /* @ngInject */
    function GroupsController($route, groupsService, messagingService, userSessionService, $rootScope, $timeout) {
        var _this = this;
        this.$route = $route;
        this.groupsService = groupsService;
        this.userSessionService = userSessionService;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.currentPage = 1;
        this.deletePendingConfirmation = [];
        this.deleteSuccess = [];
        this.errorCallback = function () {
            _this.$rootScope.loadingError = true;
            _this.$rootScope.loadingView = false;
        };
        this.loadInstitutions = function (institutions) {
            _this.institutions = institutions.children;
            if (_this.userSessionService.hasCurrentSchool()) {
                _this.selectedInstitution = _this.userSessionService.getCurrentSchool();
            }
            else {
                _this.selectedInstitution = null;
            }
            _this.onSelectSchool();
        };
        this.loadGroups = function (groups) {
            _this.groups = groups.sort(GroupsController.sortGroups);
            if (_this.groups.length) {
                _this.getInstructorList();
                _this.getStudyProgramList();
                _this.refreshDisplayedGroups();
            }
            _this.$rootScope.loadingView = false;
        };
        this.noInstructorDups = function (instructors, possible) {
            if (possible && !_this.isDuplicate(instructors, possible, "instructorId")) {
                instructors.push(possible);
            }
            return instructors;
        };
        this.noProgramDups = function (programs, possible) {
            if (!_this.isDuplicate(programs, possible, "courseSlug")) {
                programs.push(possible);
            }
            return programs;
        };
        this.handleDeleteGroupResponse = function (status) {
            if (_this.deletePendingSuccess && status >= 400) {
                _this.errorCallback();
            }
            else {
                var successIndex = _this.groups.indexOf(_this.deletePendingSuccess);
                if (successIndex < 0) {
                    _this.errorCallback();
                }
                else {
                    var confirmationIndex = _this.deletePendingConfirmation.indexOf(_this.deletePendingSuccess.groupId);
                    if (confirmationIndex >= 0) {
                        _this.deletePendingConfirmation.splice(confirmationIndex, 1);
                    }
                    _this.deleteSuccess.push(_this.deletePendingSuccess.groupId);
                    _this.deleteSuccessMessageTimeout(_this.deletePendingSuccess.groupId);
                }
            }
            _this.deletePendingSuccess = undefined;
        };
        this.deleteSuccessMessageTimeout = function (groupId) {
            var groups = _this.groups.filter(function (group) { return group.groupId === groupId; });
            _this.$timeout(function () { _this.filterDeletedGroup(groups[0]); }, MESSAGE_TIMEOUT);
        };
        this.filterGroupsByInstructor = function (group) {
            if (!_this.selectedInstructor) {
                return true;
            }
            return group.instructors && group.instructors.some(function (instructor) {
                return instructor.instructorId === _this.selectedInstructor.instructorId;
            });
        };
        this.filterGroupsByProgram = function (group) {
            if (!_this.selectedProgram) {
                return true;
            }
            return group.productGroups.TESTPREP.studyPrograms.some(function (program) {
                return program.courseSlug === _this.selectedProgram.courseSlug;
            });
        };
        this.messages = messagingService("groups");
    }
    GroupsController.sortGroups = function (groupA, groupB) {
        var defaultA = groupA.productGroups.TESTPREP.defaultGroup;
        var defaultB = groupB.productGroups.TESTPREP.defaultGroup;
        if (!defaultA && defaultB) {
            return 1;
        }
        if (defaultA && !defaultB) {
            return -1;
        }
        return 0;
    };
    GroupsController.sortInstructors = function (instructorA, instructorB) {
        if (instructorA.name.displayName > instructorB.name.displayName) {
            return 1;
        }
        if (instructorA.name.displayName < instructorB.name.displayName) {
            return -1;
        }
        return 0;
    };
    GroupsController.sortPrograms = function (programA, programB) {
        if (programA.courseSlug > programB.courseSlug) {
            return 1;
        }
        return -1;
    };
    GroupsController.prototype.$onInit = function () {
        var initData = this.$route.current.locals[INITDATA];
        this.district = initData.district;
        this.districtAdmin = initData.districtAdmin;
        this.isSchoolAdmin = initData.currentUser.isSchoolAdmin();
        this.groups = initData.groups && initData.groups.sort(GroupsController.sortGroups);
        this.tenantId = this.$route.current.params.tenantId;
        if (initData.institution && initData.district) {
            this.loadInstitutions(initData.institution);
        }
        this.updateCrumbs();
        this.checkForSuccessMessage();
        if (!this.groups || !this.groups.length) {
            return;
        }
        this.getInstructorList();
        this.getStudyProgramList();
        this.refreshDisplayedGroups();
        this.updateCrumbs();
    };
    GroupsController.prototype.getDetailPath = function (group) {
        var id = group.productGroups.TESTPREP.groupId;
        if (group.productGroups.TESTPREP.defaultGroup) {
            return ("#/" + this.tenantId + "/default-group-detail/" + id) + DEFAULT_GRADES_QUERY;
        }
        return "#/" + this.tenantId + "/group-detail/" + id;
    };
    GroupsController.prototype.onSelectSchool = function () {
        this.clearError();
        this.userSessionService.setCurrentSchool(this.selectedInstitution);
        if (this.selectedInstitution) {
            this.fetchGroups();
        }
        else {
            this.groups = void 0;
        }
        this.updateCrumbs();
    };
    GroupsController.prototype.clearError = function () { this.$rootScope.loadingError = false; };
    GroupsController.prototype.showGroups = function () { return !this.district || (this.district && !!this.selectedInstitution); };
    GroupsController.prototype.showNoGroupsMessage = function () {
        return !this.$rootScope.loadingView && (!this.filteredGroups || !this.filteredGroups.length);
    };
    GroupsController.prototype.districtAccessNotAllowed = function () { return this.district && !this.districtAdmin; };
    GroupsController.prototype.selectForDeletion = function (group) {
        var index = this.deletePendingConfirmation.indexOf(group.groupId);
        if (index < 0) {
            this.tooltipGroup = 0;
            this.deletePendingConfirmation.push(group.groupId);
        }
    };
    GroupsController.prototype.deselectForDeletion = function (group) {
        var index = this.deletePendingConfirmation.indexOf(group.groupId);
        if (index >= 0) {
            this.deletePendingConfirmation.splice(index, 1);
        }
    };
    GroupsController.prototype.deleteGroup = function (group) {
        this.deletePendingSuccess = group;
        this.groupsService.deleteGroup(this.tenantId, group).then(this.handleDeleteGroupResponse);
    };
    GroupsController.prototype.filterDeletedGroup = function (group) {
        var index = this.groups.indexOf(group);
        var deleteSuccessIndex = this.deleteSuccess.indexOf(group.groupId);
        if (deleteSuccessIndex >= 0 && index >= 0) {
            this.deleteSuccess.splice(deleteSuccessIndex, 1);
            this.groups.splice(index, 1);
            this.refreshDisplayedGroups();
        }
    };
    GroupsController.prototype.refreshDisplayedGroups = function () {
        var _this = this;
        this.refreshFilteredGroups();
        this.pages = [[]];
        this.filteredGroups.forEach(function (group) {
            var lastPage = _this.pages[_this.pages.length - 1];
            if (lastPage.length >= GROUPSPERPAGE) {
                _this.pages.push([]);
                lastPage = _this.pages[_this.pages.length - 1];
            }
            lastPage.push(group);
        });
        this.currentPage = Math.min(this.pages.length, this.currentPage);
    };
    GroupsController.prototype.getPageOfGroups = function () { return this.pages && this.pages[this.currentPage - 1]; };
    GroupsController.prototype.getGroupCount = function () {
        if (this.filteredGroups && this.filteredGroups.length > 0) {
            return this.filteredGroups.length - this.deleteSuccess.length;
        }
        return 0;
    };
    GroupsController.prototype.showPaginator = function () { return this.pages && this.pages.length > 1; };
    GroupsController.prototype.getMessage = function () {
        if (this.district && !this.districtAdmin) {
            var key_1 = "noDistrictPermission";
            return this.messages[key_1];
        }
        var key = "noGroups";
        if (this.groups && this.groups.length && (!this.filteredGroups || !this.filteredGroups.length)) {
            key += "ForFilter";
        }
        return this.messages[key];
    };
    GroupsController.prototype.isGroupDeleted = function (group) { return this.deleteSuccess.indexOf(group.groupId) >= 0; };
    GroupsController.prototype.isGroupPendingDeletion = function (group) {
        return this.deletePendingConfirmation.indexOf(group.groupId) >= 0;
    };
    GroupsController.prototype.isDeleteShowing = function (group) {
        return this.isGroupDeleted(group) || !!group.productGroups.TESTPREP.defaultGroup;
    };
    GroupsController.prototype.clearSuccessMessage = function () {
        this.showSuccessMessage = false;
        delete this.$rootScope.successMessage;
        delete this.successMessage;
    };
    GroupsController.prototype.schoolHasGroups = function () {
        return (!!this.groups && !!this.groups.length) || (!this.isSchoolAdmin && !this.district);
    };
    GroupsController.prototype.getAssignLink = function () {
        var tenantId = this.tenantId;
        if (this.district) {
            tenantId = this.selectedInstitution.institutionId;
        }
        return "#/" + tenantId + "/assign-programs";
    };
    GroupsController.prototype.setTooltip = function (group) {
        this.tooltipGroup = (group && group.groupId) || void 0;
    };
    GroupsController.prototype.isTooltipShowing = function (group) {
        return this.tooltipGroup === group.groupId;
    };
    GroupsController.prototype.checkForSuccessMessage = function () {
        var _this = this;
        if (this.$rootScope.successMessage) {
            this.successMessage = this.$rootScope.successMessage;
            this.showSuccessMessage = true;
            this.$timeout(function () {
                _this.clearSuccessMessage();
                delete _this.$rootScope.successMessage;
                delete _this.successMessage;
            }, MESSAGE_TIMEOUT);
        }
    };
    GroupsController.prototype.updateCrumbs = function () {
        if (this.district) {
            this.crumbs = [{ name: "Naviance Test Prep: District" }];
            if (this.selectedInstitution) {
                this.crumbs.push({ name: "" + this.selectedInstitution.name });
            }
        }
        else {
            this.crumbs = [{ name: "Naviance Test Prep" }];
        }
    };
    GroupsController.prototype.fetchGroups = function () {
        this.groups = void 0;
        this.instructors = void 0;
        this.studyPrograms = void 0;
        this.filteredGroups = void 0;
        this.pages = [[]];
        this.tenantId = this.selectedInstitution.institutionId;
        this.$rootScope.loadingView = true;
        this.groupsService.getAll(this.tenantId).then(this.loadGroups, this.errorCallback);
    };
    GroupsController.prototype.refreshFilteredGroups = function () {
        this.filteredGroups = this.groups.filter(this.filterGroupsByInstructor)
            .filter(this.filterGroupsByProgram);
    };
    GroupsController.prototype.getInstructorList = function () {
        this.instructors = this.groups.map(function (group) { return group.instructors; })
            .reduce(function (flat, nested) { return flat.concat(nested); }, [])
            .reduce(this.noInstructorDups, [])
            .sort(GroupsController.sortInstructors);
    };
    GroupsController.prototype.getStudyProgramList = function () {
        this.studyPrograms = this.groups
            .map(function (group) { return group.productGroups.TESTPREP.studyPrograms; })
            .reduce(function (flat, nested) { return flat.concat(nested); })
            .reduce(this.noProgramDups, [])
            .sort(GroupsController.sortPrograms);
    };
    GroupsController.prototype.isDuplicate = function (arr, possibleDup, field) {
        return arr.some(function (item) { return item[field] === possibleDup[field]; });
    };
    return GroupsController;
}());
exports.GroupsController = GroupsController;



/** WEBPACK FOOTER **
 ** ./app/groups/groups.controller.ts
 **/